import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from "@angular/core"
import { AddOnViewService } from "../../services/add-on-view.service"
import { Subject } from "rxjs"
import { filter, takeUntil } from "rxjs/operators"
import { NavigationEnd, Router } from "@angular/router"
import { AboutRoute, AboutService } from "../../services/about.service"

@Component({
    selector: "app-footer-nav",
    templateUrl: "./footer-nav.component.html",
    styleUrls: ["./footer-nav.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterNavComponent implements OnInit, OnDestroy {
    @Input() aboutRoutes: AboutRoute[] = []

    destroyed$ = new Subject()

    isAddonView = false

    leftNavRouterLink: AboutRoute | null = null
    rightNavRouterLink: AboutRoute | null = null

    constructor(
        private addOnService: AddOnViewService,
        private router: Router,
        private aboutService: AboutService
    ) {}

    ngOnInit(): void {
        this.isAddonView = this.addOnService.isAddonView
        this.setNavRouterLinks()

        this.router.events
            .pipe(
                takeUntil(this.destroyed$),
                filter((event) => event instanceof NavigationEnd)
            )
            .subscribe(() => {
                this.setNavRouterLinks()
            })
    }

    ngOnDestroy(): void {
        this.destroyed$.next()
        this.destroyed$.complete()
    }

    private setNavRouterLinks(): void {
        const [leftNavRouterLink, rightNavRouterLink] = this.aboutService.prepareNavRouterLinks(
            this.aboutRoutes,
            this.router.url
        )
        this.leftNavRouterLink = leftNavRouterLink
        this.rightNavRouterLink = rightNavRouterLink
    }
}
